import * as moment from 'moment-timezone';
import { sideTypeBuy, sideTypeSell } from './SignalI3';

export interface SignalMessagePageResponse {
  items: SignalMessageResponse[];
  pageNumber: number;
  pageSize: number;
  total: number;
}

export interface SignalMessageResponse {
  id: string;
  dateUtc: moment.Moment;
  content: EditorialMessageContentResponse;
}

export interface EditorialMessageContentResponse {
  title: string;
  imageUrl: string;
  description: string;
  link: string;
  postLink: string;
  signalValue: string;
  author?: AuthorContentResponse;
  mediaLink: string;
  category: string;
  tags: any[];
  market: string;
  dataRelatedPost: any;
  dataRelatedWebinar: any;
  dataRelatedRecording: any;
  dataRelatedCalendar: any;
  dataRelatedSignal: any;
}

export interface AuthorContentResponse {
  id: string;
  name: string;
}

export function getPostUrl(response: EditorialMessageContentResponse): string {

  if (response.dataRelatedPost) {
    return response.dataRelatedPost.postUrl;
  } else if (response.dataRelatedWebinar) {
    return response.dataRelatedWebinar.eventPostUrl;
  } else if (response.dataRelatedRecording) {
    return response.dataRelatedRecording.liveVideoUrl
  }

}

export function getEventName(response: EditorialMessageContentResponse): string {
  if (response.dataRelatedCalendar) return response.dataRelatedCalendar.name;
}

export function getSignalValue(response: EditorialMessageContentResponse): string {
  if (response.dataRelatedSignal)
    return `${response.dataRelatedSignal.positionMaintenanceId} | ${response.dataRelatedSignal.asset} | ${getDate(response.dataRelatedSignal.openUtc)} | ${getSide(response.dataRelatedSignal.sideType)}`;
  else
    return "";
}

export function getSide(sideType: number) {
  return sideType === 0 ? sideTypeBuy : sideTypeSell;
}

export function getDate(openUtc: string) {
  const options: any = {
    year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', second: 'numeric',
    hour12: false
  };
  return Intl.DateTimeFormat('en-US', options).format(new Date(openUtc));
}


// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/SignalMessagePageResponse.ts